import React from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { MAX_DATE_RANGE_DAYS } from "helpers/dictionary";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportShipmentsReturnsFilters, getReportShipmentsReturnsAction } from "redux/actions/Reports/reportShipmentsReturns/reportShipmentsReturnsActions";
import { useSearch } from "hooks/useSearch";

export const ReportShipmentsReturnsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportShipmentsReturns);

  const handleSubmit = (e, isPdf = true) => {
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, MAX_DATE_RANGE_DAYS, setSnackbar)) return;
    dispatch(getReportShipmentsReturnsAction({ startDate, endDate, station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte de Devoluciones de Embarque" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportShipmentsReturns"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportShipmentsReturnsFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingShipmentsReturns}
      />
      {isLoadingComp?.loadingShipmentsReturns && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
